import { LoanPartnerCommunicationOverviewPage } from '@interhyp/module-credit-communication';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { Navigation, NavItems } from '../../navigation/Navigation';

export function SubmissionCommunicationOverviewWrapper(): JSX.Element {
  const { submissionId } = useParams<{ submissionId: string }>();
  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/submissions/${submissionId}`, translation: 'navigation.summary' },
      { to: `/credit/submissions/${submissionId}/documents`, translation: 'navigation.documents' },
      {
        to: `/credit/submissions/${submissionId}/communication`,
        translation: 'navigation.communication',
      },
    ];
  }, [submissionId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <LoanPartnerCommunicationOverviewPage aggregateId={submissionId} resourceType="SUBMISSION" />
    </>
  );
}
